<template>
  <div class="layout">
    <div class="layout__header">
      <h3>Producto o servicio</h3>
    </div>
    <div class="row">
      <div class="col-xs-12 col-md-8">
        <div class="form-group">
          <input-field
            :tooltip="
              modelValue.nombre_item !== ''
                ? modelValue.nombre_item
                : 'Seleccione...'
            "
            readonly
            v-model="modelValue.nombre_item"
            id="item"
            placeholder="Producto o servicio"
          >
            <span>Ítem</span>
            <span
              v-if="errores.id_item"
              class="helper-text text-danger"
              slot="helper"
            >
              <strong>{{ errores.id_item[0] }}</strong>
            </span>
          </input-field>
          <button @click="buscarItems" class="btn-info" type="button">
            <i class="fa fa-search"></i>
          </button>
        </div>
      </div>
      <div class="col-xs-12 col-md-4">
        <div class="form-field">
          <input-field
            :readonly="!precioEditable"
            vMoney
            :format="moneyPersonalizado"
            placeholder="$ #,###.##"
            id="precio"
            v-model="modelValue.precio"
          >
            <span>Precio</span>
            <span
              v-if="errores.precio"
              class="helper-text text-danger"
              slot="helper"
            >
              <strong>{{ errores.precio[0] }}</strong>
            </span>
          </input-field>
        </div>
      </div>
      <div class="col-xs-12 col-md-4">
        <div class="form-field">
          <input-field
            vMoney
            :format="porcentaje"
            placeholder="###.## %"
            id="porcentaje_iva"
            readonly
            v-model="modelValue.porcentaje_iva"
          >
            <span>% IVA</span>
          </input-field>
        </div>
      </div>
      <div class="col-xs-12 col-md-4">
        <div class="form-field">
          <input-field
            vMoney
            :format="money"
            readonly
            placeholder="$ #,###.##"
            id="iva"
            :value="iva"
          >
            <span>IVA</span>
          </input-field>
        </div>
      </div>
      <div class="col-xs-12 col-md-4">
        <div class="form-field">
          <div class="form-group">
            <input-field
              vMoney
              :format="decimalPersonalizado"
              placeholder="#,###.##"
              id="cantidad"
              v-model="modelValue.cantidad"
            >
              <span>Cantidad</span>
              <span
                v-if="errores.cantidad"
                class="helper-text text-danger"
                slot="helper"
              >
                <strong>{{ errores.cantidad[0] }}</strong>
              </span>
            </input-field>
          </div>
        </div>
      </div>
      <div class="col-xs-12 col-md-4">
        <div class="form-field">
          <input-field
            @keyup.native="calcularDescuentoTotal"
            vMoney
            :format="porcentaje"
            placeholder="% ###.##"
            id="porcentaje_descuento"
            v-model="modelValue.porcentaje_descuento"
          >
            <span>% Descuento</span>
          </input-field>
        </div>
      </div>
      <div class="col-xs-12 col-md-4">
        <div class="form-field">
          <input-field
            @keyup.native="calcularPorcentajeDescuento"
            vMoney
            :format="money"
            placeholder="$ #,###.##"
            id="total_descuento"
            v-model="modelValue.total_descuento"
          >
            <span>Total de descuento</span>
          </input-field>
        </div>
      </div>
      <div class="col-xs-12 col-md-4">
        <div class="form-field">
          <label>
            <input type="checkbox" disabled v-model="modelValue.irbpnr" />
            <span>IRBPNR</span>
          </label>
        </div>
      </div>
      <div class="col-xs-12 col-md-4">
        <div class="form-field">
          <input-field
            vMoney
            :format="money"
            readonly
            placeholder="$ #,###.##"
            id="ice"
            :value="ice"
          >
            <span>ICE</span>
          </input-field>
        </div>
      </div>
      <div class="col-xs-12 col-md-4">
        <div class="form-field">
          <input-field
            readonly
            vMoney
            :format="money"
            placeholder="$ #,###.##"
            id="totalIrbpnr"
            :value="irbpnr"
          >
            <span>Total IRBPNR</span>
          </input-field>
        </div>
      </div>
      <div class="col-xs-12 col-md-4">
        <div class="form-field">
          <input-field
            readonly
            vMoney
            :format="money"
            placeholder="$ #,###.##"
            id="total"
            :value="total"
          >
            <span>Total</span>
            <span
              v-if="errores.total"
              class="helper-text text-danger"
              slot="helper"
            >
              <strong>{{ errores.total[0] }}</strong>
            </span>
          </input-field>
        </div>
      </div>
      <div class="col-xs-12 col-md-4">
        <div class="form-field">
          <label for="mostrarDetalle">
            <input
              type="checkbox"
              id="mostrarDetalle"
              v-model="modelValue.mostrar_detalle"
            /><span>Mostrar detalle</span>
          </label>
        </div>
      </div>
      <div class="col-xs-12 col-md-8">
        <div class="form-field">
          <textarea-field
            v-model="modelValue.detalle"
            placeholder="Agregue una nota"
            id="detalle"
          >
            <span>Detalle</span>
          </textarea-field>
        </div>
      </div>
    </div>
    <div class="modal-buttons">
      <button
        @click="$emit('cancelar')"
        class="btn-danger btn--text"
        type="button"
      >
        <i class="fa fa-ban"></i><span>Cancelar</span>
      </button>
      <button @click="aceptarItem" class="btn-success" type="button">
        <i class="fa fa-check"></i><span>Aceptar</span>
      </button>
    </div>
    <modal height="auto" width="70%" scrollable name="items">
      <lista-item
        :tipo="tipo"
        :searchButton="false"
        @selected="seleccionarItem"
        :filterStatus="false"
        :createButton="true"
      ></lista-item>
    </modal>
  </div>
</template>

<script>
export default {
  props: {
    grava_iva: {
      type: Boolean,
      required: false,
      default: true
    },
    decimales_compras: {
      required: false,
      default: 2
    },
    moneyPersonalizado: {
      type: Object,
      required: true
    },
    decimalPersonalizado: {
      type: Object,
      required: true
    },
    precioEditable: {
      type: Boolean,
      required: true,
    },
    value: {
      type: Object,
      default: function () {
        return {
          id_item: "",
          cantidad: 1,
          precio: 0,
          precio_produccion: 0,
          total_descuento: 0,
          iva: 0,
          ice: 0,
          porcentaje_descuento: 0,
          total: 0,
          nombre_item: "",
          porcentaje_iva: 0,
          porcentaje_ice: 0,
          id_iva: "",
          id_ice: "",
          irbpnr: false,
          total_irbpnr: 0,
          detalle: "",
          total_parcial: 0,
          total_impuestos: 0,
          total_inicial: 0,
          tarifa_especifica_ice: 0,
          numero_unidades_ice: 0,
          total_parcial_ice: 0,
          porcentaje_ed_valorem: 0,
          cantidad_ice: 0,
          cantidad_irbpnr: 0,
          precio_sin_subsidio: 0,
          valor_subsidio: 0,
          mostrar_detalle: true,
          coste: 0,
        };
      },
    },
    valorIrbpnr: {
      type: Number,
      required: true,
    },
    tipoComprobante: {
      type: String,
      required: true,
    },
    tipo: {
      type: String,
      required: false,
      default: "E",
    },
  },
  data: function () {
    return {
      modelValue: this.value,
      money: money,
      money2: money2,
      porcentaje: porcentaje,
      decimal: decimal,
      errores: {
        id_item: undefined,
        cantidad: undefined,
        precio: undefined,
      },
    };
  },
  computed: {
    iva: function () {
      let totalParcial = this.total_parcial;
      let porcentajeIva = parseFloat(this.modelValue.porcentaje_iva);
      if (isNaN(porcentajeIva)) porcentajeIva = 0;
      let iva = (porcentajeIva / 100) * totalParcial;
      iva = round(iva);
      this.modelValue.iva = iva;
      return iva;
    },
    total: function () {
      let total =
        parseFloat(this.total_parcial) +
        parseFloat(this.iva) +
        parseFloat(this.ice) +
        parseFloat(this.irbpnr);
      total = round(total);
      this.modelValue.total = total;
      return total;
    },
    total_parcial_ice: function () {
      let cantidad = parseFloat(this.modelValue.cantidad);
      if (isNaN(cantidad)) cantidad = 0;
      let precioVenta = parseFloat(this.modelValue.precio);
      if (isNaN(precioVenta)) precioVenta = 0;
      if (
        this.modelValue.porcentaje_ed_valorem !== null &&
        this.modelValue.precio_produccion !== null
      ) {
        let precioProduccion =
          cantidad * parseFloat(this.modelValue.precio_produccion);
        if (precioProduccion > precioVenta) {
          precioProduccion = round(precioProduccion);
          this.modelValue.total_parcial_ice = precioProduccion;
          return precioProduccion;
        }
      }
      let porcentajeIva = parseFloat(this.modelValue.porcentaje_iva);
      if (isNaN(porcentajeIva)) porcentajeIva = 0;
      let iva = (porcentajeIva / 100) * precioVenta;
      precioVenta += iva;
      precioVenta = round(precioVenta);
      this.modelValue.total_parcial_ice = precioVenta;
      return precioVenta;
    },
    ice: function () {
      let totalConIva = this.total_parcial_ice;
      let ice = 0;
      if (this.modelValue.porcentaje_ice !== null)
        ice = totalConIva * (parseFloat(this.modelValue.porcentaje_ice) / 100);
      else if (this.modelValue.porcentaje_ed_valorem !== null)
        ice =
          totalConIva *
          (parseFloat(this.modelValue.porcentaje_ed_valorem) / 100);
      if (isNaN(ice)) ice = 0;
      ice = round(ice);
      if (this.modelValue.tarifa_especifica_ice !== null) {
        if (this.modelValue.numero_unidades_ice === null)
          ice +=
            parseFloat(this.modelValue.cantidad) *
            parseFloat(this.modelValue.tarifa_especifica_ice);
        else
          ice +=
            parseInt(
              (parseFloat(this.modelValue.cantidad_ice) *
                parseFloat(this.modelValue.cantidad)) /
                this.modelValue.numero_unidades_ice
            ) * parseFloat(this.modelValue.tarifa_especifica_ice);
      }
      if (isNaN(ice)) ice = 0;
      ice = round(ice);
      this.modelValue.ice = ice;
      return ice;
    },
    irbpnr: function () {
      if (this.modelValue.irbpnr) {
        let cantidad =
          parseFloat(this.modelValue.cantidad) *
          parseFloat(this.modelValue.cantidad_irbpnr);
        if (isNaN(cantidad)) cantidad = 0;
        let irbpnr = cantidad * this.valorIrbpnr;
        irbpnr = round(irbpnr);
        this.modelValue.total_irbpnr = irbpnr;
        return irbpnr;
      } else return 0;
    },
    total_inicial: function () {
      let cantidad = parseFloat(this.modelValue.cantidad);
      if (isNaN(cantidad)) cantidad = 0;
      let precio = parseFloat(this.modelValue.precio);
      if (isNaN(precio)) precio = 0;
      let totalInicial = cantidad * precio;
      totalInicial = round(totalInicial);
      this.modelValue.total_inicial = totalInicial;
      return totalInicial;
    },
    total_parcial: function () {
      let totalInicial = this.total_inicial;
      let totalDescuento = parseFloat(this.modelValue.total_descuento);
      if (isNaN(totalDescuento)) totalDescuento = 0;
      let totalParcial = totalInicial - totalDescuento;
      totalParcial = round(totalParcial);
      this.modelValue.total_parcial = totalParcial;
      return totalParcial;
    },
  },
  methods: {
    aceptarItem: function () {
      this.errores = {};
      let errores = false;
      if (
        this.modelValue.cantidad === "" ||
        parseFloat(this.modelValue.cantidad) < 1
      ) {
        this.errores.cantidad = [
          "La cantidad es requerida y debe ser mayor o igual a 1.",
        ];
        errores = true;
      }
      if (this.modelValue.precio === "") {
        this.errores.cantidad = ["El precio es requerido."];
        errores = true;
      }
      if (this.modelValue.total === "") {
        this.errores.total = ["El total es requerido."];
        errores = true;
      }
      if (this.modelValue.id_item === "") {
        this.errores.id_item = ["Debe seleccionar un ítem."];
        errores = true;
      }
      if (!errores) this.$emit("input", this.modelValue);
      else swal("Tiene validaciones que corregir.", "Mensaje", "warning");
    },
    buscarItems: function () {
      this.$modal.show("items");
    },
    seleccionarItem: function (item) {
      this.modelValue.id_item = item.codigo;
      this.modelValue.nombre_item = item.nombre;
      this.modelValue.valor_subsidio = item.valor_subsidio;
      this.modelValue.precio_sin_subsidio = item.precio_sin_subsidio;
      if (this.tipoComprobante === "99" || !this.grava_iva) {
        this.modelValue.precio =
          parseFloat(item.precio_subsidiado) *
          (1 + parseFloat(item.tarifa_iva.porcentaje) / 100);
        this.modelValue.id_iva = "6";
        this.modelValue.id_ice = null;
        this.modelValue.irbpnr = false;
        this.modelValue.porcentaje_iva = 0;
      } else {
        this.modelValue.precio = item.precio_subsidiado;
        this.modelValue.id_iva = item.id_tarifa_iva;
        this.modelValue.id_ice = item.id_tarifa_ice;
        this.modelValue.porcentaje_iva = item.tarifa_iva.porcentaje;
        if (item.tarifa_ice !== null) {
          this.modelValue.porcentaje_ice = item.tarifa_ice.porcentaje;
          this.modelValue.tarifa_especifica_ice =
            item.tarifa_ice.tarifa_especifica;
          this.modelValue.numero_unidades_ice = item.tarifa_ice.numero_unidades;
          this.modelValue.porcentaje_ed_valorem =
            item.tarifa_ice.porcentaje_ed_valorem;
          this.modelValue.cantidad_ice = item.cantidad_ice;
        }
        this.modelValue.precio_produccion = item.precio_produccion;
        this.modelValue.cantidad_irbpnr = item.cantidad_irbpnr;
        if (this.modelValue.cantidad_irbpnr === null)
          this.modelValue.cantidad_irbpnr = 1;
        this.modelValue.irbpnr = item.irbpnr === "S";
      }
      this.modelValue.coste = item.costo;
      this.$modal.hide("items");
    },
    calcularDescuentoTotal: function () {
      let descuentoTotal =
        this.total_inicial * (this.modelValue.porcentaje_descuento / 100);
      if (descuentoTotal <= this.total_inicial) {
        if (isNaN(descuentoTotal)) descuentoTotal = 0;
      } else {
        this.modelValue.porcentaje_descuento = 0;
        descuentoTotal = 0;
      }
      this.modelValue.total_descuento = round(descuentoTotal);
    },
    calcularPorcentajeDescuento: function () {
      let porcentajeDescuento =
        (parseFloat(this.modelValue.total_descuento) / this.total_inicial) *
        100;
      if (porcentajeDescuento <= 100) {
        if (isNaN(porcentajeDescuento)) porcentajeDescuento = 0;
      } else {
        this.modelValue.total_descuento = 0;
        porcentajeDescuento = 0;
      }
      this.modelValue.porcentaje_descuento = round(porcentajeDescuento);
    },
    calcularImpuestosTotales: function () {
      let totalImpuestos =
        parseFloat(this.iva) + parseFloat(this.ice) + parseFloat(this.irbpnr);
      this.modelValue.total_impuestos = round(totalImpuestos);
    },
  },
  watch: {
    "modelValue.iva": function () {
      this.calcularImpuestosTotales();
    },
    "modelValue.ice": function () {
      this.calcularImpuestosTotales();
    },
    "modelValue.total_irbpnr": function () {
      this.calcularImpuestosTotales();
    },
  },
  mounted: function () {
    this.calcularPorcentajeDescuento();
  },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/forms/comprobantes/ItemComprobante.vue